module.exports = __webpack_public_path__ + "assets/img/5.c428d7e9.png";